import { RatingStars } from '../history/RatingStars';

export const AlbumGridView = ({
  item,
  albumNumber,
  preventOrphanWords,
  activeContent,
  onGenresClick,
  onReviewClick
}) => (
  <>
    <img
      src={item.album.images[1]?.url}
      alt={item.album.name}
      className="col-start-1 row-start-1 w-full aspect-square object-fill"
    />
    <div className="grid grid-rows-[auto] sm:grid-cols-[2.5rem,1fr,2.5rem] max-sm:grid-cols-1 place-content-between gap-1 p-3 leading-5">
      <div className="sm:col-span-3 content-center justify-items-center text-center
          pangram-sans-narrow-extrabold md:text-xl md:leading-6 text-lg leading-5">
        {preventOrphanWords(item.album.name)}
      </div>
      <div className="content-center justify-items-center text-center sm:text-left max-sm:row-start-1">
        #{albumNumber}
      </div>
      <div className="content-center justify-items-center text-center">
        {preventOrphanWords(item.album.artist)}
      </div>
      <div className="content-center justify-items-center text-center sm:text-right">
        {item.album.releaseDate}
      </div>
      <div className="sm:col-span-3 content-center justify-items-center text-center">
        <RatingStars
          rating={item.rating}
          hasReview={!!item.review}
          hasGenres={item.album.genres?.length > 0}
          activeContent={activeContent}
          onGenresClick={onGenresClick}
          onReviewClick={onReviewClick}
          item={item}
        />
      </div>
    </div>
  </>
);